import { getAuthData } from '../../Utils/AuthUtils';
import apiService from '../../Services/APIService';
import { checkAPIResponse } from '../../Utils/APIResponseUtils';
import { getTransactionTypeIdByName, transactionTypeMapping } from '../../Utils/Utilities';

const authData = getAuthData();
const currentUserID = authData?.UserID ? String(authData.UserID) : "";

export const manageTransactionAPI = async (transactionData, operation = 'ADD') => {
  try {
    const isDelete = operation === 'DELETE';
    const d = transactionData;

    const preparedTransactionData = {
      changeType: isDelete ? 'DEL' : operation,
      xnID: d.xnID || 0,
      connID: d.connID || 0,
      xnNo: d.xnNo || d.invoiceNo || '',
      xnDate: d.xnDate || d.xnDateAPI || new Date().toISOString().split('T')[0],
      dueDate: d.dueDate || d.dueDateAPI || '',
      xnTypeID: d.xnTypeID || d.transactionTypeID || 1,
      xnFile: d.xnFile || '',
      connContactID: d.connContactID || 0,
      connContactName: d.connContactName || d.contactPerson || '',
      connCC: d.connCC || 91,
      connMobile: d.connMobile || '',
      connEmail: d.connEmail || '',
      currencyID: d.currencyID || 1,
      amtSubTotal: parseFloat(d.amtSubTotal || 0),
      amtGrandTotal: parseFloat(d.amtGrandTotal || d.amount || 0),
      connReferenceNo: d.connReferenceNo || d.referenceNo || '',
      notes: d.notes || '',
      shareByEmail: d.shareByEmail || false,
      shareByWhatsapp: d.shareByWhatsapp || false
    };

    const result = await apiService.sendChange(7, 'set', preparedTransactionData);
    checkAPIResponse(result);
    return result;
  } catch (error) {
    console.error(`${operation} transaction API error:`, error);
    throw error;
  }
};
// NEW FUNCTION: Bulk transaction save
export const saveTransactionsBulk = async (transactionDataArray) => {
  try {
    if (!Array.isArray(transactionDataArray) || transactionDataArray.length === 0) {
      throw new Error('No transaction data provided for bulk save');
    }

    // Prepare transaction data - match the TxnInfo table type exactly
    const preparedTransactionData = transactionDataArray.map(txn => {
      const transactionTypeName = String(txn.TransactionType || '').trim();

      // Use dynamic lookup instead of hardcoded mapping
      const transactionTypeID = getTransactionTypeIdByName(transactionTypeName) || 1;

      return {
        TxnID: 0, // bigint - always 0 for new records
        ConnID: parseInt(txn.ConnectionID) || 0, // bigint - ensure it's a number
        XnTypID: transactionTypeID, // smallint 
        XnNo: String(txn.XnNo || txn.InvoiceNo || '').trim() || '', // nvarchar(50) - ensure not null
        XnDate: txn.XnDate || txn.InvoiceDate || new Date().toISOString().split('T')[0], // date - YYYY-MM-DD format
        PTAmt: parseFloat(txn.PreTaxAmount) || 0, // decimal(18,2) - cannot be null, default to 0
        TotalAmt: parseFloat(txn.TotalAmount) || 0, // decimal(18,2) - cannot be null
        Notes: String(txn.Notes || '').trim() || '' // nvarchar(1000) - ensure not null, empty string if no notes
      };
    });


    // Create the payload structure that matches your C# web service expectations
    const payload = [{
      src: 'EXCEL', // Source identifier
      transactionParams: preparedTransactionData
    }];

    console.log('Sending bulk transaction data:', payload);

    // Call the bulk transaction API (moduleID = 7, actionType = 'setBulk')
    const result = await apiService.sendChange(7, 'setBulk', payload);

    checkAPIResponse(result);

    if (result.error) {
      throw new Error(result.message || 'API request failed');
    }
    return {
      success: true,
      message: 'Transactions saved.',
    };

  } catch (error) {
    console.error('Bulk transaction save API error:', error);
    throw error;
  }
};
export const getTransactionDetailAPI = async (xnID, getType = '') => {
  try {
    const result = await apiService.getData(6, 'getDetails', { xnID, getType }, { isWeb: true });

    const updatePackage = JSON.parse(result.updatePackage);
    const data = updatePackage.Table1[0];

    return {
      transaction: data,
      rawData: data
    };
  } catch (error) {
    console.error('getTransactionDetail API error:', error);
    throw error;
  }
};


export const getTransactionAPI = async ({ xnTypeID, prdType, prdQty, year, month }) => {
  try {
    const payload = [{
      xnTypeID,
      prdType,
      prdQty,
      year,
      month
    }];

    const result = await apiService.getData(8, 'get', payload);
    // Parse the updatePackage to get the actual data
    const updatePackage = JSON.parse(result.updatePackage);
    const data = updatePackage.Table1;

    return data
  } catch (error) {
    console.error('getConnectionDetail API error:', error);
    throw error;
  }
};